<template>
    <div>
		<div class="row">
            <div class="col-md-12 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Achievement (YTD {{ this.monthBefore }} {{ this.currentYear }}) </div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <h5 class="text-center">Achievement (YTD {{ this.monthBefore }} {{ this.currentYear }}) </h5>
                    <ReportResultTable  :reportname="'Achievement'" :reportdata="rkaprealisasi" :loading="loading.table" :reporturl="''" :issuccess="loading.isSuccess" style="width:100%;"/> 	
                </div>
            </div>
            <div class="col-md-12 mb-4" v-if="false">
                <div class="box-title-border-with-detail px-3 py-1" style="">Payment Method (YTD {{ this.monthBefore }} {{ this.currentYear }}) </div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <h5 class="text-center">Payment Method (YTD {{ this.monthBefore }} {{ this.currentYear }})</h5>
                    <ReportResultTable :reportname="'PaymentMethod'" :reportdata="paymentmethoddata" :loading="loading.paymentmethod" :reporturl="''" :issuccess="loading.isSuccess" style="width:100%;"/> 	
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Komposisi Branch Type Per Sales Area</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <h5 class="text-center">Komposisi Branch Type Per Sales Area</h5>
                    <BarChart v-if="showchartbyareakomposisi" v-loading.body="loading.komposisi" :data="komposisibyareadata" :width="500" :height="300"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Sales Per Category (YTD {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <h5 class="text-center">Growth By Area (YTD {{ this.monthBefore }} {{ this.currentYear }})</h5>
                    <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="260" style="margin-top:20px" />
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Sales Per Category (YTD {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <h5 class="text-center">Growth By Area (YTD {{ this.monthBefore }} {{ this.currentYear }})</h5>
                    <BarChart v-if="showchartbyareagrowth" v-loading.body="loading.table" :data="chartdatabyproduct" :width="500" :height="320"/>
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <div class="box-title-border-with-detail px-3 py-1" style="">Komposisi Per Area (YTD {{ this.monthBefore }} {{ this.currentYear }})</div>
                <div class="box-border-with-title pt-3 pb-3 px-1" style="overflow-x: auto;">
                    <h5 class="text-center">Komposisi Per Area (YTD {{ this.monthBefore }} {{ this.currentYear }})</h5>
                    <PieChart v-loading.body="loading.table" :data="piechartdata" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default {
    extends:Fuel,
	components: {
        ReportResultTable,
        BarChart,
        LineChart,
        PieChart,
    },
    props: ['tabIndex','tabName', 'tabLabel', 'showchartbyareakomposisi','showchartbyareagrowth'],
    computed:{

	},
    watch:{
        showchartbyareakomposisi() {
            //console.log('showchartbyareakomposisi: ' + this.showchartbyareakomposisi)
        },
        showchartbyareagrowth() {
            //console.log('showchartbyareagrowth: ' + this.showchartbyareagrowth)
        }
    },
    mounted(){
        this.getSalesByProductMonthly()
        //this.getPaymentMethodSummary()
        //this.getRkapRealisasi()
        //this.getKomposisiByArea()
    },
    data(){
		return {
            showchart: true,

            loading: {
                table: false,
                achievement: false,
                paymentmethod: false,
                komposisi: false,
            },

            chartdata: [],
            chartdatabyproduct : [],
            paymentmethoddata: [],
            rkaprealisasi: [],

            komposisibyareadata: [],

            piechartdata:[],

            monthBefore: this.getMonthName(Penanggalan().bulan-1),
            currentYear: Penanggalan().tahun,
            
            stacked : false,
            plantno: this.$route.query.plant ? this.$route.query.plant : '',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : 'SPBU',
			period: this.$route.query.period ? this.$route.query.period : 'monthly',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : 'product',
			detail3: this.$route.query.detail3 ? this.$route.query.detail3 : '',
			area: this.$route.query.area ? this.$route.query.area : 'area',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			satgas: this.$route.query.satgas ? this.$route.query.satgas : '',
            date: { 
                Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
                End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().bulanKemarin, 
            },
                                
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : this.getLastDayOfMonth(Penanggalan().tahun, (Penanggalan().bulan-1))], 
                
        }
    },
    methods:{
        async getSalesByProductMonthly(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/bright/businessstoretrackingsalesarea?'
            //this.urlRequestParams+='/fuel2/payment?'


            //this.urlRequestParams+='&date-range-start='+this.date.Start
            //this.urlRequestParams+='&date-range-end='+this.date.End

            //console.log('daterange: ' + this.dateRange)
            //console.log('this.dateRange[0]: ' + this.dateRange[0])
            //console.log('this.dateRange[1]: ' + this.dateRange[1])

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

            //if(this.monthRange[0] != 'undefined')
            //this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

            //if(this.monthRange[1] != 'undefined')
            //this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

            this.urlRequestParams+='&period='+this.period
            this.urlRequestParams+='&plant='+this.plantno
            this.urlRequestParams+='&station='+this.stationid
            this.urlRequestParams+='&type='+this.stationtype
            this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&owner='+this.owner
            this.urlRequestParams+='&lokasi='+this.lokasi
            this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&satgas='+this.satgas
            this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2 + '_' + this.detail3

            //additional
            this.urlRequestParams+='&store-tracking=1'

            //this.urlRequestParams+='&city='+this.city
            //this.urlRequestParams+='&presentation='+this.presentation
            //this.urlRequestParams+='&detailView='+this.detail
            //this.urlRequestParams+='&active='+this.active

            this.loading.table = true;
            this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.reportdata = response.data;

                    this.rkaprealisasi = this.reportdata.data.achievement;
                    
                    this.setChartKomposisiByBranchType();
                    this.setChartProductMonthlySalesArea();
                    this.setChartProduct();
                    this.pieChartProduct();

                    this.redrawChartGrowth()

                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.table = false;
                })
        },

        async getPaymentMethodSummary(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/paymentMethodSummaryByArea?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&type='+this.stationtype

            this.loading.paymentmethod = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.paymentmethoddata = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.paymentmethod = false;
                })
        },

        async getRkapRealisasi(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/achievementRkapRealisasi?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&area=area'

            this.loading.achievement = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.rkaprealisasi = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.achievement = false;
                })
        },

        async getKomposisiByArea(){

            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/fuel2/komposisiVolumeByArea?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
            this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&type='+this.stationtype

            this.loading.komposisi = true;
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{ 
                    this.loading.isSuccess = true;
                    this.komposisibyareadata = response.data;
                    //console.log('this.reportdata: ' + JSON.stringify(this.reportdata))

                    let prefix = ''
                    let valuecol = 'PerformSales'
                    let legend = 'ProductGroup'
                    let label = 'SalesArea'
                    
                    this.komposisibyareadata = this.processBarChart(this.komposisibyareadata.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false, this.stacked);	
                    
                    this.redrawChartKomposisi()

                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.komposisi = false;
                })
            },

        setChartKomposisiByBranchType() {
            let data = this.reportdata.data.komposisi_per_branch;
            let prefix = ''
            let valuecol = 'TotalSales'
            let legend = 'BranchType'
            let label = 'SalesArea'
            
            this.komposisibyareadata = this.processBarChart(data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false, this.stacked);	
            
            this.redrawChartKomposisi()
        },
        setChartProductMonthlySalesArea() {
            let data = this.reportdata.data.komposisi_per_category;
            //line chart
            let prefix = 'AREA '
            let valuecol = 'TotalSales'
            let legend = 'SalesArea'
            let label = 'CategoryType'

            this.chartdata = this.processBarChart(data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false, this.stacked);			
        }, 
        setChartProduct(){
            let data = this.reportdata.data.komposisi_per_category;
            let prefix = ''
            let valuecol = 'TotalSales'
            let legend = 'CategoryType'
            let label = 'SalesArea'
            
            this.chartdatabyproduct = this.processBarChart(data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false, this.stacked);	
            
            //console.log('this.chartdatabyproduct: ' + JSON.stringify(this.chartdatabyproduct))
        },
        pieChartProduct()
        {
            let item = this.reportdata.data.komposisi_per_area;
            var warna = [];

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].SalesArea] = Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].SalesArea, 
                    amount: item[row].TotalSales,
                };

                value.push(main);
                idx++;
            }

            let result = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            //console.log('result: ' + JSON.stringify(result))          
            this.piechartdata = result
            //console.log('groupedArray: ' + JSON.stringify(groupedArray));

            return result 
        },

        redrawChartKomposisi() {
            this.showchartbyareakomposisi = false
            setTimeout(() => {
                this.showchartbyareakomposisi = true
                //console.log('Redraw chart komposisi')
            }, 500);
        },

        redrawChartGrowth() {
            this.showchartbyareagrowth = false
            setTimeout(() => {
                this.showchartbyareagrowth = true
                //console.log('Redraw chart growth')
            }, 500);
        },
    }
}
</script>

<style scoped>
.box-title-border-with-detail {
    background-color: #409EFF ; /**#0077FF */
    color:white;
    display: block; /**inline-block */
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}

.box-border-with-title {
    border: 0.13rem solid #409EFF;  /**#0077FF */
    /*border-top-right-radius: 4px; */
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
</style>
